<button
	[class]="cssClass ? cssClass : 'btn btn-primary'"
	[ngClass]="{ 'btn-loading': state === states.LOADING }"
	[tabindex]="tabIndex"
	[type]="type"
	[id]="id"
	[disabled]="disabled || (disabledOnLoading && state === states.LOADING)"
	(click)="clickEvent($event)"
	(keydown.space)="clickEvent($event)"
>
	<span class="label">{{ value }}</span>
	<i *ngIf="iconName" [ngClass]="['cfe', 'cfe-' + iconName]"></i>

	<span class="spinner-container">
		<span class="spinner-border text-secondary" role="status">
			<span class="sr-only">Loading...</span>
		</span>
	</span>
</button>
